import { Connect } from '@genesislcap/foundation-comms';
import { observable } from '@microsoft/fast-element';
import { DI } from '@microsoft/fast-foundation';
import { Route } from '@microsoft/fast-router';
import { PROFILE_RIGHTS } from '../utils';
import { IStructuredChatService } from './structured-chat.service';
import { IUserService } from './user.service';

export enum NOTIFY_DASHBOARD_TAB {
  NONE = '',
}

export interface INotificationService {
  dashboardTab?: NOTIFY_DASHBOARD_TAB;
  redirectToExecution(): void;
  redirectToProjectPage(projectId: string): void;
  openStructuredChat(negotiationId: string): void;
  redirectToMarketPage(): void;
  redirectToDashboard(tab?: NOTIFY_DASHBOARD_TAB): void;
  getDashboardTab(): string;
  clearDashboardTab(): void;
}

class NotificationServiceImpl implements INotificationService {
  @IStructuredChatService structuredChatService: IStructuredChatService;
  @IUserService userService: IUserService;

  @observable dashboardTab: NOTIFY_DASHBOARD_TAB = null;

  constructor(@Connect private connect: Connect) {}

  redirectToExecution() {
    Route.path.push('execution');
  }

  redirectToProjectPage(projectId: string) {
    Route.path.push('project/' + projectId);
  }

  openStructuredChat(negotiationId: string) {
    this.structuredChatService.openStructuredChat({
      selectedVPPAIDs: [],
      selectedRFQIDs: [],
      selectedNegotiationID: negotiationId,
    });
  }

  redirectToMarketPage() {
    Route.path.push('market-depth');
  }

  redirectToDashboard(tab?: NOTIFY_DASHBOARD_TAB) {
    if (tab) {
      this.dashboardTab = tab;
    }
    if (this.userService.getFilteredPermissions().includes(PROFILE_RIGHTS.SELLER_DASHBOARD_VIEW)) {
      Route.path.push('dashboard');
    } else if (
      this.userService.getFilteredPermissions().includes(PROFILE_RIGHTS.BUYER_DASHBOARD_VIEW)
    ) {
      Route.path.push('buyer-dashboard');
    } else {
      Route.path.push('welcome')
    }
  }

  getDashboardTab(): string {
    return this.dashboardTab;
  }

  clearDashboardTab() {
    this.dashboardTab = NOTIFY_DASHBOARD_TAB.NONE;
  }
}

export const INotificationService = DI.createInterface<INotificationService>((x) =>
  x.singleton(NotificationServiceImpl)
);
